"use client";

import { Icon } from "@/components/ui/icon";
import { Label } from "@/components/ui/label";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { cn } from "@/lib/utils";
import type { ComponentProps, ReactNode } from "react";

type FilterLabelProps = ComponentProps<typeof Label> & {
  hint?: string;
  children: ReactNode;
};

export function FilterLabel({
  hint,
  children,
  className,
  ...props
}: FilterLabelProps) {
  return (
    <Label
      className={cn("inline-flex items-center gap-1.5", className)}
      {...props}
    >
      {children}
      {hint ? (
        <TooltipProvider delayDuration={0}>
          <Tooltip>
            <TooltipTrigger asChild>
              <Icon
                icon="InfoCircleSolid"
                className="h-[14px] w-[14px] shrink-0 cursor-pointer text-foreground/25"
              />
            </TooltipTrigger>
            <TooltipContent className="max-w-[260px]">{hint}</TooltipContent>
          </Tooltip>
        </TooltipProvider>
      ) : null}
    </Label>
  );
}
